import { ChevronsRightIcon } from "lucide-react";
import React, { useEffect, useState } from "react";
import {
  AddButton,
  CustomConfirmModal,
  PaginationDropdown,
} from "../../common/GeneralComponent";
import { Pagination } from "@mui/material";
import DataTable from "react-data-table-component";
import { Link, useNavigate } from "react-router-dom";
import { fetchData } from "../../../utils/functions";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Loader from "../../partials/Loader";
import "font-awesome/css/font-awesome.min.css";

import GeneralFooter from "../../common/GeneralFooter";
import PermissionButton from "../../common/PermissionButton";

const ManagePermissions = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [permissionsData, setPermissionsData] = useState([]);
  const [status, setStatus] = useState("");
  const [search, setSearch] = useState("");
  const [isModalVisible, setModalVisible] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [loader, setLoader] = useState(true);

  const { user: loggedInUser } = useSelector((state) => state.auth);
  const permissions = loggedInUser?.user_permissions || [];

  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
    totalPages: 0,
  });

  // Only one group expanded at a time
  const [expandedGroup, setExpandedGroup] = useState(null);

  const fetchPermissions = async () => {
    try {
      setLoader(true);
      const queryParams = {
        nameFilter: search || undefined,
        statusFilter: status !== "" ? status : undefined,
        page: pagination.currentPage,
        limit: pagination.pageSize,
      };

       


      const response = await fetchData(
        "permission",
        "GET",
        null,
        {},
        queryParams,
        navigate,
        "/manage-permission",
        dispatch
      );

      const data = response?.data || [];
      setPermissionsData(data);

      // Expand first group by default
      if (data.length > 0) {
        setExpandedGroup(data[0].group);
      }

      setPagination((prev) => ({
        ...prev,
        totalItems: response?.pagination?.totalItems || 0,
        totalPages: response?.pagination?.totalPages || 1,
      }));

      setLoader(false);
    } catch (error) {
      console.error("Error fetching permissions:", error);
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchPermissions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage, pagination.pageSize, search, status]);

  const handleDelete = async () => {
    setModalVisible(false);

    setPermissionsData((prev) =>
      prev.map((g) => ({
        ...g,
        permissions: g.permissions.filter((p) => p.id !== selectedId),
      }))
    );

    try {
      const response = await fetchData(
        `permission`,
        "DELETE",
        { id: selectedId },
        {},
        {},
        navigate,
        "/manage-permission",
        dispatch
      );

      if (!response?.success) {
        throw new Error(
          response?.message || "Failed to delete the permission."
        );
      }

      toast.success("Permission deleted successfully.");
    } catch (error) {
      console.error("Error deleting permission:", error);
      toast.error(
        error?.message || "An error occurred while deleting the permission."
      );
      fetchPermissions();
    }
  };

  const showDeleteModal = (id) => {
    setSelectedId(id);
    setModalVisible(true);
  };

  const handlePageChange = (event, value) => {
    setPagination((prev) => ({ ...prev, currentPage: value }));
  };

  const handlePageSizeChange = (size) => {
    setPagination((prev) => ({ ...prev, pageSize: size, currentPage: 1 }));
  };

  // Toggle accordion (only one open at a time)
  const toggleGroup = (group) => {
    setExpandedGroup((prev) => (prev === group ? null : group));
  };

  const columns = [
    {
      name: <span className="text-[0.819rem] uppercase">Sr.No</span>,
      cell: (row, index) => (
        <span className="text-[0.85em] font-medium">{index + 1}</span>
      ),
      width: "70px",
    },
    {
      name: <span className="text-[0.819rem] uppercase">Permission Name</span>,
      selector: (row) => row.permission_name,
      sortable: true,
    },
    {
      name: <span className="text-[0.819rem] uppercase">Status</span>,
      cell: (row) => (
        <span
          className={`py-1 px-2 text-[0.85em] rounded ${
            row.status === 1 ? "bg-success text-white" : "bg-red-500 text-white"
          }`}
        >
          {row.status === 1 ? "Active" : "Inactive"}
        </span>
      ),
    },
  ];
  {
      if (
        permissions.includes("permission-update") ||
        permissions.includes("permission-delete")
      ) {
        columns.push({
          name: <span className="text-[0.819rem] uppercase">Action</span>,
          cell: (row) => (
            <div className="flex gap-2">
              {/* <Link
              to={`/manage-permissions/edit/${row.id}`}
              state={{ permission: row }}
            >
              <i className="fa-solid fa-pen-to-square fa-lg"></i>
            </Link>
            <button onClick={() => showDeleteModal(row.id)}>
              <i className="fa fa-trash fa-lg text-primaryDark"></i>
            </button> */}

              <PermissionButton
                hasPermission={permissions.includes("permission-update")}
                // faIcon="fa-solid fa-pen-to-square fa-lg"
                // onlyIcon
                to={`/manage-permissions/edit/${row.id}`}
                faIcon="fa-solid fa-pen-to-square fa-lg"
                onlyIcon={true}
                // className="text-primaryDark hover:text-[#137e81]" // keeps it like your <a>
                enabledClass="" // no background
                disabledClass="opacity-50 cursor-not-allowed"
              />
              <PermissionButton
                hasPermission={permissions.includes("permission-delete")}
                faIcon="fa fa-trash fa-lg text-primaryDark"
                onlyIcon
                onClick={() => showDeleteModal(row.id)}
                className="p-2 rounded-full bg-gray-200 text-[#137e81] hover:text-white"
                enabledClass=""
                disabledClass="opacity-50 cursor-not-allowed bg-gray-300"
              />

              <CustomConfirmModal
                isVisible={isModalVisible}
                onConfirm={handleDelete}
                onCancel={() => setModalVisible(false)}
                message="Are you sure you want to delete this permission?"
              />
            </div>
          ),
        });
      }
}

  const customStyles = {
    headCells: {
      style: {
        border: "1px solid #f3f3f3",
        backgroundColor: "#fff",
        color: "black",
        fontWeight: "bold",
        fontSize: "1.075rem",
        textAlign: "center",
      },
    },
    cells: {
      style: {
        border: "1px solid #f3f3f3",
        textAlign: "center",
      },
    },
  };

  return (
    <div className="my-4 w-full flex flex-col justify-between items-center">
      {loader && <Loader />}
      <div className="flex lg:flex-row flex-col lg:justify-between gap-3 w-full">
        <h1 className="lg:text-[1.475rem] text-[1rem] text-[#212529] font-bold">
          Manage Permissions
        </h1>
        {/* <Link to="add">
          <AddButton text="Add" icon={ChevronsRightIcon} />
        </Link> */}

        <PermissionButton
          hasPermission={permissions.includes("permission-create")}
          to="add"
          faIcon="fa fa-plus"
          text="Add"
          className="flex items-center gap-2 py-[0.375rem] px-[0.75rem] rounded font-[InterLight] lg:text-[15px] text-[12px]"
          enabledClass="bg-[#be9609] text-white w-auto opacity-95 hover:opacity-85"
          disabledClass="bg-[#be9609] text-white opacity-50 cursor-not-allowed"
        />
      </div>

      <div className="rounded-lg mb-[30px] mt-4 shadow w-full bg-white">
        <div className="p-4 flex md:flex-row flex-col gap-3 justify-between border-b border-lightGray">
          <h1 className="lg:text-[0.875rem] text-[13px] uppercase text-[#856800] font-bold">
            Permission List
          </h1>
        </div>
        <div className="p-[1.25rem] w-full">
          <div className="flex lg:flex-row flex-col lg:justify-between gap-2 mb-[6px] w-full">
            <PaginationDropdown
              value={pagination.pageSize}
              onChange={handlePageSizeChange}
              options={[
                { value: 10, label: "10" },
                { value: 20, label: "20" },
                { value: 30, label: "30" },
              ]}
            />
            <input
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setPagination((prev) => ({ ...prev, currentPage: 1 }));
              }}
              placeholder="Search..."
              type="search"
              className="font-light text-[#212529] text-[14px] bg-[#f1f4f8] border border-[#ebeef2] rounded-md px-3 py-1 outline-none"
            />
          </div>

          {permissionsData.length === 0 ? (
            <div className="text-center py-6 text-gray-600">
              No permissions found.
            </div>
          ) : (
            permissionsData.map((group) => (
              <div key={group.group} className="border rounded mb-3">
                {/* Accordion Header */}
                <div
                  className={`flex justify-between items-center cursor-pointer px-4 py-2 transition-all duration-200 
                    ${
                      expandedGroup === group.group
                        ? "bg-[#137e81] border-l-4 border-green-600 text-white"
                        : "bg-gray-100 hover:bg-gray-200 text-[#212529]"
                    }`}
                  onClick={() => toggleGroup(group.group)}
                >
                  <div className="flex items-center gap-3 text-[15px] font-semibold">
                    {expandedGroup === group.group ? (
                      <i className="fa fa-minus-square text-white"></i>
                    ) : (
                      <i className="fa fa-plus-square text-gray-500"></i>
                    )}
                    <span>
                      {group.group}{" "}
                      <span
                        className={`text-sm font-normal ${
                          expandedGroup === group.group
                            ? "text-white/80"
                            : "text-gray-600"
                        }`}
                      >
                        ({group.permissions.length})
                      </span>
                    </span>
                  </div>
                  {expandedGroup === group.group ? (
                    <i className="fa fa-chevron-up text-white"></i>
                  ) : (
                    <i className="fa fa-chevron-down text-gray-500"></i>
                  )}
                </div>

                {/* Accordion Content */}
                {expandedGroup === group.group && (
                  <div className="p-3">
                    <DataTable
                      columns={columns}
                      data={group.permissions}
                      customStyles={customStyles}
                      highlightOnHover
                      dense
                      noHeader
                    />
                  </div>
                )}
              </div>
            ))
          )}
          <GeneralFooter
            pagination={pagination}
            handlePageChange={handlePageChange}
            handlePageSizeChange={handlePageSizeChange}
            dataLength={permissionsData.length}
          />
        </div>
      </div>
    </div>
  );
};
export default ManagePermissions;
